module.exports = __webpack_public_path__ + "img/kisspng-arrow-5d43e475e48c97.4811358315647304859362.825e8e93.png";